import { StrategicTerritoriesWidgetKey } from '@inference.engine/widgets/web';
import { getSavedStrategicTerritoriesSnapshot } from '@/features/strategic-territories-widget';
import { ArtifactPreviewFallback } from './ArtifactPreviewFallback';
import { ArtifactPreviewWidget } from './ArtifactPreviewWidget';
import { ResolveArtifactPreview } from './ResolveArtifactPreview';

interface Props {
  artifactId: string;
}

export function StrategicTerritoriesArtifactPreview({ artifactId }: Props) {
  return (
    <ResolveArtifactPreview
      queryKey="strategic-territories-artifact-snapshot"
      artifactId={artifactId}
      queryFn={getSavedStrategicTerritoriesSnapshot}
      render={(data) => (
        <ArtifactPreviewWidget
          artifactKey={StrategicTerritoriesWidgetKey}
          data={data as unknown as Record<string, unknown>}
          fallback={<ArtifactPreviewFallback />}
        />
      )}
    />
  );
}
